// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useUtilityOperatorApiClient } from '../../../contexts/UtilityApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import { InstrumentConfiguration } from '@digitalasset/utility-api-ts-client';
import { INSTRUMENT_IDENTIFIER } from '../../../utils/constants';

export const useReserveInstrumentConfiguration = (): UseQueryResult<InstrumentConfiguration, string> => {
  const utilityOperatorApi = useUtilityOperatorApiClient();
  const { crossChainRepresentative } = useParties();
  const request = {
    registrar: crossChainRepresentative,
    instrumentIdentifier: {
      id: INSTRUMENT_IDENTIFIER,
      source: crossChainRepresentative,
      scheme: 'RegistrarInternalScheme'
    }
  };

  return useQuery({
    queryKey: ['getInstrumentConfiguration', request],
    queryFn: async () =>
      utilityOperatorApi.getInstrumentConfiguration(request),
    refetchInterval: false,
  });
};
